import { API_BASE_URL } from "./apiConfig";
import { buildLogoutPayload } from "./jwt";
import { clearSession, isColdStart, touchPresence } from "./session";

if (isColdStart()) {
    const staleToken = (() => {
        try {
            return localStorage.getItem("token");
        } catch {
            return null;
        }
    })();

    if (staleToken) {
        try {
            let username = "";
            let roleid = "";
            try {
                username = localStorage.getItem("username") || "";
                roleid = localStorage.getItem("roleid") || "";
            } catch {
            }

            fetch(`${API_BASE_URL}/auth/logout`, {
                method: "POST",
                keepalive: true,
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": staleToken,
                },
                body: JSON.stringify(buildLogoutPayload(staleToken, { username, roleid })),
            }).catch(() => {
            });
        } catch {
        }
    }

    clearSession();
}

touchPresence();
